import React from 'react';
import { object, string } from 'prop-types';

const TextCarouselTitle = ({ title, icon }) => (
    <div className="text-carousel-title-container">
        {title && <h4 className="text-carousel-title">{title}</h4>}
        {icon && <div className="text-carousel-logo logo-image">{icon}</div>}
    </div>
);

TextCarouselTitle.propTypes = {
    icon: object,
    title: string,
};

TextCarouselTitle.defaultProps = {
    icon: null,
    title: null,
};

export default TextCarouselTitle;
